import { defineStore } from "pinia";
import { MeResponse } from "@/types/user";

export interface MessagingStore {
    access_token: string,
    sessionInfo: MeResponse | null
}

export const useMessagingStore = defineStore('messaging', {
    state: (): MessagingStore => {
        return {
            access_token: '',
            sessionInfo: null
        }
    },
    actions: {},
    getters: {}
})
